// src/pages/UserListPage.tsx
import BaseTable from "@/components/BaseTable/BaseTable";
import CustomButton from "@/components/common/Button";
import { getTenantId } from "@/lib/storeManager";
import NpsUserService from "@/services/APIs/NpsUserService";
import { gridName } from "@/utils/constant/gridName";
import navigationRoutes from "@/utils/navigationRoutes";
import { SubmissionResult } from "@/utils/types/NpsUser";
import { ProColumns } from "@ant-design/pro-components";
import { useQuery } from "@tanstack/react-query";
import { Eye } from "lucide-react";
import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const NpsUserListPage: React.FC = () => {
  const navigate = useNavigate();
  const tenantId = getTenantId() ?? "";
  const [searchParams] = useSearchParams();
  const urlPage = parseInt(searchParams.get("page") ?? "1", 10);
  const urlPageSize = parseInt(searchParams.get("pageSize") ?? "10", 10);
  const [page, setPage] = useState(urlPage);
  const [pageSize, setPageSize] = useState(urlPageSize);

  const {
    data,
    isLoading,
    refetch: refetchUsers,
  } = useQuery({
    queryKey: ["npsUsers", tenantId, page, pageSize],
    queryFn: () => NpsUserService.listNpsUsers(page, pageSize),
    enabled: !!tenantId,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    staleTime: 60_000,
  });

  const handleView = (id: string) => {
    console.log(id);
  };

  const columns: ProColumns<SubmissionResult>[] = [
    {
      title: "User Name",
      render: (_, record) => `${record.subFstName}`,
    },
    { title: "Mobile", dataIndex: "mobile" },
    { title: "Status", dataIndex: "status" },
    { title: "PRAN Card", dataIndex: "pranNumber" },
    { title: "ACK ID", dataIndex: "ackId" },
    { title: "Receipt Number", dataIndex: "receiptNumber" },
    {
      title: "Actions",
      width: 100,
      valueType: "option",
      render: (_, record) => [
        <CustomButton
          key="view"
          onClick={() => handleView(record.ackId)}
          icon={<Eye size={16} />}
          type="text"
          title="View Nps User"
        />,
      ],
    },
  ];

  //   const toolBarRender = () => {
  //     return [
  //       <CustomButton
  //         key="add"
  //         type="primary"
  //         onClick={handleCreate}
  //         title="Add User"
  //       >
  //         <Plus size={16} className="mr-1" /> {t("Add User")}
  //       </CustomButton>,
  //     ];
  //   };

  return (
    <BaseTable<SubmissionResult>
      loading={isLoading}
      columns={columns}
      dataSource={(data?.results ?? []) as unknown as SubmissionResult[]}
      page={page}
      pageSize={pageSize}
      total={data?.count}
      onPageChange={(page, pageSize) => {
        setPage(page);
        setPageSize(pageSize ?? 10);
        searchParams.set("page", page.toString());
        searchParams.set("pageSize", pageSize.toString());
        navigate(
          `${navigationRoutes.NPS_USER_LIST}?${searchParams.toString()}`
        );
        refetchUsers();
      }}
      rowKey="id"
      headerTitle="Nps Users List"
      toolBarRender={undefined}
      request={() => refetchUsers()}
      tableName={gridName.npsUserTable}
    />
  );
};

export default NpsUserListPage;
